import { keyframes } from "@emotion/react";
import styled from "@emotion/styled/macro";
import { ReactNode } from "react";
import { mobileMaxWidth } from "components/atoms/GlobalStyles";

const Slideout = ({
  children,
  onClose,
  style,
  width,
}: {
  children: ReactNode;
  onClose?: () => void;
  style?: React.CSSProperties;
  /** Desktop panel width (e.g. "50%"). Defaults to ~80% / 1200px. Full width on mobile. */
  width?: string;
}) => {
  return (
    <Overlay onClick={onClose} data-testid="slideout-overlay">
      <SlideoutContainer
        onClick={(e) => e.stopPropagation()}
        className="slideout"
        data-testid="slideout-panel"
        style={style}
        $width={width}
      >
        {children}
      </SlideoutContainer>
    </Overlay>
  );
};

const slide = keyframes`
  from {
    transform: translateX(100%);
  }
  to {
    transform: translateX(0);
  }`;

const SlideoutContainer = styled.div<{ $width?: string }>`
  width: ${({ $width }) => $width ?? "1200px"};
  min-height: 100vh;
  min-width: ${({ $width }) => $width ?? "80%"};
  max-width: 100%;
  position: fixed;
  right: 0;
  background-color: #fff;
  animation: ${slide} 0.5s ease-in-out forwards;

  @media (max-width: ${mobileMaxWidth}px) {
    width: 100%;
    min-width: 100%;
  }
`;
const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1001;
`;
export { Slideout };
